import { SiteNav } from "@/components/SiteNav";
import { SiteFooter } from "@/components/SiteFooter";
import { Hero } from "@/components/Hero";
import { PropertyFacts } from "@/components/PropertyFacts";
import { Story } from "@/components/Story";
import { House } from "@/components/House";
import { Gallery } from "@/components/Gallery";
import { Location } from "@/components/Location";
import { Booking } from "@/components/Booking";

export default function HomePage() {
  return (
    <div className="relative">
      <SiteNav />
      <main>
        <Hero />
        <PropertyFacts />
        <Story />
        <House />
        <Gallery preview />
        <Location />
        <Booking />
      </main>
      <SiteFooter />
    </div>
  );
}
